import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const defaultSteps = [
    { number: 1, label: 'Información básica' },
    { number: 2, label: 'Imágenes' }
];

const StepIndicator = ({ currentStep, steps: customSteps, propertyId }) => {
    const steps = customSteps || defaultSteps;
    const totalSteps = steps.length;
    const currentStepData = steps.find(s => s.number === currentStep);
    const previousStep = steps.find(s => s.number === currentStep - 1);
    const previousHref = previousStep?.path && propertyId
        ? previousStep.path.replace(':id', propertyId)
        : null;

    return (
        <div className="mb-8">
            {/* Móvil: barra de progreso compacta */}
            <div className="sm:hidden">
                <div className="flex items-center justify-between mb-2">
                    {previousHref ? (
                        <Link
                            to={previousHref}
                            className="text-xs text-blue-600 hover:underline flex items-center gap-1"
                        >
                            ← {previousStep.label}
                        </Link>
                    ) : (
                        <span />
                    )}
                    <span className="text-xs font-medium text-gray-500">
                        {currentStep} / {totalSteps}
                    </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                        className="bg-blue-500 h-2 rounded-full transition-all duration-300"
                        style={{ width: `${(currentStep / totalSteps) * 100}%` }}
                    />
                </div>
                <p className="mt-2 text-sm font-semibold text-blue-600">{currentStepData?.label}</p>
            </div>

            {/* Desktop: círculos con etiquetas */}
            <div className="hidden sm:flex items-start justify-center">
                {steps.map((step, index) => {
                    const isCompleted = step.number < currentStep;
                    const isCurrent = step.number === currentStep;
                    const isClickable = isCompleted && step.path && propertyId;
                    const href = isClickable ? step.path.replace(':id', propertyId) : null;

                    const bubble = (
                        <div className={`flex items-center justify-center w-10 h-10 rounded-full transition-colors ${
                            isCompleted
                                ? isClickable ? 'bg-green-500 group-hover:bg-green-600' : 'bg-green-500'
                                : isCurrent ? 'bg-blue-500' : 'bg-gray-200'
                        }`}>
                            {isCompleted ? (
                                <CheckCircleIcon className="w-6 h-6 text-white" />
                            ) : (
                                <span className={`text-lg font-medium ${isCurrent ? 'text-white' : 'text-gray-500'}`}>
                                    {step.number}
                                </span>
                            )}
                        </div>
                    );

                    const labelClass = `mt-2 text-xs font-medium text-center max-w-[72px] ${
                        isCurrent ? 'text-blue-500' : isClickable ? 'text-green-700' : 'text-gray-500'
                    }`;

                    const containerClass = 'flex flex-col items-center group';

                    return (
                        <React.Fragment key={step.number}>
                            {isClickable ? (
                                <Link to={href} className={containerClass} title={`Volver a ${step.label}`}>
                                    {bubble}
                                    <span className={`${labelClass} hover:underline`}>{step.label}</span>
                                </Link>
                            ) : (
                                <div className={containerClass}>
                                    {bubble}
                                    <span className={labelClass}>{step.label}</span>
                                </div>
                            )}
                            {index < steps.length - 1 && (
                                <div className={`flex-shrink-0 w-16 h-1 mx-3 mt-5 ${isCompleted ? 'bg-green-500' : 'bg-gray-200'}`} />
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default StepIndicator;
